var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBar'),_c('ModelView'),_c('CarouselSection',{attrs:{"ShowItem":_vm.showItem,"ingredients":"ingredients"}}),_c('v-main',{staticClass:"pt-12 mt-12"},[_c('FooterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }